var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.location.id == _vm.value.id
        ? _c(
            "v-img",
            {
              staticClass: "align-end soli-round mb-3 white--text",
              staticStyle: { cursor: "pointer" },
              attrs: {
                gradient:
                  "to top right, rgba(123, 177, 224, 0.8), rgba(123, 177, 224, 0.8)",
                src: "/grandview-exterior.webp",
                height: "142px",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("input", _vm.location)
                },
              },
            },
            [
              _c("v-card-title", { staticClass: "font-weight-bold" }, [
                _vm._v(_vm._s(_vm.location.name)),
              ]),
              _vm._v(" "),
              _c("v-card-subtitle", { staticClass: "py-0" }, [
                _vm._v(_vm._s(_vm.location.address)),
              ]),
              _vm._v(" "),
              _c("v-card-subtitle", { staticClass: "py-0" }, [
                _vm._v(_vm._s(_vm.location.email)),
              ]),
              _vm._v(" "),
              _c("v-card-subtitle", { staticClass: "pt-0" }, [
                _vm._v(_vm._s(_vm.location.phone)),
              ]),
              _vm._v(" "),
              _vm.icon
                ? _c(
                    "v-icon",
                    {
                      staticClass: "px-5",
                      staticStyle: {
                        position: "absolute",
                        top: "33%",
                        right: "0px",
                      },
                      attrs: { color: "white" },
                    },
                    [_vm._v(_vm._s(_vm.icon))]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-expand-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.value.id == _vm.location.id,
                expression: "value.id == location.id",
              },
            ],
          },
          [
            _vm.location.CM
              ? _c(
                  "v-container",
                  { staticClass: "flex py-0" },
                  [
                    _c(
                      "v-list-item-avatar",
                      { staticClass: "shadow-blue", attrs: { size: "64" } },
                      [
                        _c("v-img", {
                          attrs: { src: _vm.location.CM?.profile_photo_url },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "align-self-center" }, [
                      _c("small", [_vm._v("Community Manager")]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.location.CM.name))]),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-card-actions",
              { staticClass: "justify-space-around mb-5" },
              [
                _c(
                  "v-btn",
                  { attrs: { icon: "", href: "tel:" + _vm.location.phone } },
                  [
                    _c("v-icon", { attrs: { color: "dark" } }, [
                      _vm._v("phone"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "small",
                      {
                        staticClass: "mt-1 panel-text",
                        staticStyle: { "text-transform": "none" },
                      },
                      [_vm._v("Call")]
                    ),
                  ],
                  1
                ),
                _c(
                  "v-btn",
                  { attrs: { icon: "", href: "sms:" + _vm.location.phone } },
                  [
                    _c("v-icon", { attrs: { color: "dark" } }, [_vm._v("sms")]),
                    _vm._v(" "),
                    _c(
                      "small",
                      {
                        staticClass: "mt-1 panel-text",
                        staticStyle: { "text-transform": "none" },
                      },
                      [_vm._v("Text")]
                    ),
                  ],
                  1
                ),
                _c(
                  "v-btn",
                  { attrs: { icon: "", href: "mailto:" + _vm.location.email } },
                  [
                    _c("v-icon", { attrs: { color: "dark" } }, [
                      _vm._v("email"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "small",
                      {
                        staticClass: "mt-1 panel-text",
                        staticStyle: { "text-transform": "none" },
                      },
                      [_vm._v("Email")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }